import { YesNoPromptCommand } from "slotworks/commands/error/yes-no-prompt-command";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import Contract from "slotworks/utils/contracts/contract";

export function SoundPromptCommand(messageId: string = "sound_prompt", showLoadScreen: boolean = false, remember: boolean = false) {
    return new Contract<boolean>((resolve) => {

        if (remember && Services.sound.isMutePreferenceSet()) {
            if (!Services.sound.getMuted()) {
                Services.sound.unmute();
            }
            resolve(Services.sound.getMuted());
            return;
        }

        const prompt = new PromptContent(["yes_no"], Infinity, Layers.Alerts);

        prompt.setText("body", Services.translations.get(messageId));

        YesNoPromptCommand(
            prompt,
            () => {
                if (showLoadScreen) {
                    Services.sound.unmuteLoadScreen().then(() => {
                        resolve(true);
                    });
                } else {
                    Services.sound.unmute();
                    resolve(true);
                }

            },
            () => {
                Services.sound.mute();
                resolve(false);
            }
        ).execute();
    });
}
